import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import SearchableList from './MenuItems/SearchableList.js';
import { M as Menu } from './SubMenu-7f19d88b.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'react-desc';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-form/ComboBox';
import '@elliemae/ds-icons/ChevronSmallRight';
import '@elliemae/ds-icons/MoreOptionsVert';
import '@elliemae/ds-shared/FocusGroup';
import '@elliemae/ds-hidden';
import '@elliemae/ds-button';
import '@elliemae/ds-popper';
import '@elliemae/ds-popper/interaction';
import 'styled-components';
import 'lodash';
import '@elliemae/ds-classnames';
import 'react-spring/web.cjs';
import '@elliemae/ds-utilities/hooks';
import '@elliemae/ds-utilities/system';
import '@elliemae/ds-icons/Checkmark';
import '@elliemae/ds-truncated-tooltip-text';
import './MenuItems/Separator.js';
import '@elliemae/ds-separator';
import '@elliemae/ds-shared/CheckableGroup';
import './MenuItems/SearchableGroup.js';
import '@elliemae/ds-form/SearchBox';
import './VirtualMenuList.js';
import 'react-window';
import './utils/useHeightByAmountOfItems.js';
import './MenuContext.js';
import '@elliemae/ds-form/Checkbox';
import './MenuItems/CheckboxGroup.js';
import './MenuItems/RadioGroup.js';

function MenuCombobox(_ref) {
  var _ref$dropdownFilterOp = _ref.dropdownFilterOptions,
      dropdownFilterOptions = _ref$dropdownFilterOp === void 0 ? {} : _ref$dropdownFilterOp,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onSelectMenuItem = _ref.onSelectMenuItem,
      onSelectMenuItem = _ref$onSelectMenuItem === void 0 ? function () {
    return null;
  } : _ref$onSelectMenuItem,
      innerRef = _ref.innerRef,
      _ref$maxOptions = _ref.maxOptions,
      maxOptions = _ref$maxOptions === void 0 ? 10 : _ref$maxOptions,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      rest = _objectWithoutProperties(_ref, ["dropdownFilterOptions", "options", "onSelectMenuItem", "innerRef", "maxOptions", "loading"]);

  return /*#__PURE__*/React.createElement(Menu, _extends({}, rest, {
    classProps: {
      menuComboBox: true
    },
    innerRef: innerRef,
    visible: true
  }), /*#__PURE__*/React.createElement(SearchableList, {
    appendTermInList: true,
    extraListProps: dropdownFilterOptions,
    items: options,
    onSelectMenuItem: onSelectMenuItem,
    maxOptions: maxOptions,
    loading: loading
  }));
}

MenuCombobox.propTypes = {
  /** Options */
  dropdownFilterOptions: PropTypes.shape({}),

  /** The option or menu items to render */
  options: PropTypes.arrayOf(PropTypes.object),

  /** Handler when a menu item is selected */
  onSelectMenuItem: PropTypes.func,

  /** Internal ref */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** Max options to display in the list */
  maxOptions: PropTypes.number,

  /** Is loading */
  loading: PropTypes.bool
};

export default MenuCombobox;
//# sourceMappingURL=MenuCombobox.js.map
